/* eslint-disable no-magic-numbers */
import React from 'react'

import ArrowRight from 'assets/icons/arrow-right'
import ArrowLeft from 'assets/icons/arrow-left'

import { PaginationIconWrapper, PaginationPageNumber, PaginationWrapper } from './style'

const Pagination = ({
  activePages,
  numberOfPages,
  nextPage,
  prevPage,
  nextSection,
  prevSection,
  selectPage,
  dataTest
}) => {
  if (numberOfPages < 8) {
    const pages = []

    for (let i = 1; i <= numberOfPages; i++) {
      pages.push(i)
    }
    const result = pages.map((page) => {
      return (
        <PaginationPageNumber
          key={page}
          id={page}
          onClick={() => {
            return selectPage(page)
          }}
          isSelected={activePages === page}
          data-test={activePages === page ? 'active-page' : 'page'}
        >
          {page}
        </PaginationPageNumber>
      )
    })
    return (
      <PaginationWrapper data-test={dataTest}>
        <PaginationIconWrapper data-test="previous-page-btn" disabled={activePages === 1} onClick={prevPage}>
          <ArrowLeft />
        </PaginationIconWrapper>
        {result}
        <PaginationIconWrapper data-test="next-page-btn" disabled={activePages === numberOfPages} onClick={nextPage}>
          <ArrowRight />
        </PaginationIconWrapper>
      </PaginationWrapper>
    )
  }
  if (activePages < 5) {
    return (
      <PaginationWrapper data-test={dataTest}>
        <PaginationIconWrapper data-test="previous-page-btn" disabled={activePages === 1} onClick={prevPage}>
          <ArrowLeft />
        </PaginationIconWrapper>
        <PaginationPageNumber
          key={1}
          id={1}
          onClick={() => {
            return selectPage(1)
          }}
          isSelected={activePages === 1}
          data-test={activePages === 1? 'active-page' : 'page'}
        >
          1
        </PaginationPageNumber>
        <PaginationPageNumber
          key={2}
          id={2}
          onClick={() => {
            return selectPage(2)
          }}
          isSelected={activePages === 2}
          data-test={activePages === 2? 'active-page' : 'page'}
        >
          2
        </PaginationPageNumber>
        <PaginationPageNumber
          key={3}
          id={3}
          onClick={() => {
            return selectPage(3)
          }}
          isSelected={activePages === 3}
          data-test={activePages === 3? 'active-page' : 'page'}
        >
          3
        </PaginationPageNumber>
        <PaginationPageNumber
          key={4}
          id={4}
          onClick={() => {
            return selectPage(4)
          }}
          isSelected={activePages === 4}
          data-test={activePages === 4? 'active-page' : 'page'}
        >
          4
        </PaginationPageNumber>
        <PaginationPageNumber
          key={5}
          id={5}
          onClick={() => {
            return selectPage(5)
          }}
          isSelected={activePages === 5}
          data-test={activePages === 5? 'active-page' : 'page'}
        >
          5
        </PaginationPageNumber>
        <PaginationIconWrapper data-test="next-section-btn" onClick={nextSection}>
          ...
        </PaginationIconWrapper>
        <PaginationPageNumber
          key={numberOfPages}
          id={numberOfPages}
          onClick={() => {
            return selectPage(numberOfPages)
          }}
          isSelected={activePages === numberOfPages}
          data-test={activePages === numberOfPages? 'active-page' : 'page'}
        >
          {numberOfPages}
        </PaginationPageNumber>
        <PaginationIconWrapper data-test="next-page-btn" disabled={activePages === numberOfPages} onClick={nextPage}>
          <ArrowRight />
        </PaginationIconWrapper>
      </PaginationWrapper>
    )
  }
  if (activePages > numberOfPages - 4) {
    return (
      <PaginationWrapper data-test={dataTest}>
        <PaginationIconWrapper data-test="previous-page-btn" disabled={activePages === 1} onClick={prevPage}>
          <ArrowLeft />
        </PaginationIconWrapper>
        <PaginationPageNumber
          key={1}
          id={1}
          onClick={() => {
            return selectPage(1)
          }}
          isSelected={activePages === 1}
          data-test={activePages === 1? 'active-page' : 'page'}
        >
          1
        </PaginationPageNumber>
        <PaginationIconWrapper data-test="previous-section-btn" onClick={prevSection}>
          ...
        </PaginationIconWrapper>
        <PaginationPageNumber
          key={numberOfPages - 4}
          id={numberOfPages - 4}
          onClick={() => {
            return selectPage(numberOfPages - 4)
          }}
        >
          {numberOfPages - 4}
        </PaginationPageNumber>
        <PaginationPageNumber
          key={numberOfPages - 3}
          id={numberOfPages - 3}
          onClick={() => {
            return selectPage(numberOfPages - 3)
          }}
          isSelected={activePages === numberOfPages - 3}
          data-test={activePages === numberOfPages - 3? 'active-page' : 'page'}
        >
          {numberOfPages - 3}
        </PaginationPageNumber>
        <PaginationPageNumber
          key={numberOfPages - 2}
          id={numberOfPages - 2}
          onClick={() => {
            return selectPage(numberOfPages - 2)
          }}
          isSelected={activePages === numberOfPages - 2}
          data-test={activePages === numberOfPages - 2? 'active-page' : 'page'}
        >
          {numberOfPages - 2}
        </PaginationPageNumber>
        <PaginationPageNumber
          key={numberOfPages - 1}
          id={numberOfPages - 1}
          onClick={() => {
            return selectPage(numberOfPages - 1)
          }}
          isSelected={activePages === numberOfPages - 1}
          data-test={activePages === numberOfPages - 1? 'active-page' : 'page'}
        >
          {numberOfPages - 1}
        </PaginationPageNumber>
        <PaginationPageNumber
          key={numberOfPages}
          id={numberOfPages}
          onClick={() => {
            return selectPage(numberOfPages)
          }}
          isSelected={activePages === numberOfPages}
          data-test={activePages === numberOfPages? 'active-page' : 'page'}
        >
          {numberOfPages}
        </PaginationPageNumber>
        <PaginationIconWrapper data-test="next-page-btn" disabled={activePages === numberOfPages} onClick={nextPage}>
          <ArrowRight />
        </PaginationIconWrapper>
      </PaginationWrapper>
    )
  }
  return (
    <PaginationWrapper data-test={dataTest}>
      <PaginationIconWrapper data-test="previous-page-btn" disabled={activePages === 1} onClick={prevPage}>
        <ArrowLeft />
      </PaginationIconWrapper>
      <PaginationPageNumber
        key={1}
        id={1}
        onClick={() => {
          return selectPage(1)
        }}
        isSelected={activePages === 1}
        data-test={activePages === 1? 'active-page' : 'page'}
      >
        1
      </PaginationPageNumber>
      <PaginationIconWrapper data-test="previous-section-btn" onClick={prevSection}>
        ...
      </PaginationIconWrapper>
      <PaginationPageNumber
        key={activePages - 1}
        id={activePages - 1}
        onClick={() => {
          return selectPage(activePages - 1)
        }}
      >
        {activePages - 1}
      </PaginationPageNumber>
      <PaginationPageNumber
        key={activePages}
        id={activePages}
        onClick={() => {
          return selectPage(activePages)
        }}
        isSelected="true"
        data-test='active-page'
      >
        {activePages}
      </PaginationPageNumber>
      <PaginationPageNumber
        key={activePages + 1}
        id={activePages + 1}
        onClick={() => {
          return selectPage(activePages + 1)
        }}
      >
        {activePages + 1}
      </PaginationPageNumber>
      <PaginationIconWrapper data-test="next-section-btn" onClick={nextSection}>
        ...
      </PaginationIconWrapper>
      <PaginationPageNumber
        key={numberOfPages}
        id={numberOfPages}
        onClick={() => {
          return selectPage(numberOfPages)
        }}
        isSelected={activePages === numberOfPages}
        data-test={activePages === numberOfPages? 'active-page' : 'page'}
      >
        {numberOfPages}
      </PaginationPageNumber>
      <PaginationIconWrapper data-test="next-page-btn" disabled={activePages === numberOfPages} onClick={nextPage}>
        <ArrowRight />
      </PaginationIconWrapper>
    </PaginationWrapper>
  )
}

export default Pagination
